import { render, staticRenderFns } from "./General.vue?vue&type=template&id=8c5afed2&"
import script from "./General.vue?vue&type=script&lang=ts&"
export * from "./General.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8c5afed2', component.options)
    } else {
      api.reload('8c5afed2', component.options)
    }
    module.hot.accept("./General.vue?vue&type=template&id=8c5afed2&", function () {
      api.rerender('8c5afed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ControlBajaCliente/VerDetalle/General.vue"
export default component.exports